import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "../../services/authentication/authentication.context";

export const ProtectedRoute = () => {
    const { isAuthenticated } = useAuth();

    return (
             isAuthenticated === false  ?  
             <Navigate to="/" /> : <Outlet /> 
           );
};
